<div class="view-reminder-dialog">
    <div class="reminder-header">
      <span>Reminders</span>
    </div>
    <div class="reminder-overview-details">
        <div class="cd-item">
        <div class="cd-title">Notification subject</div>
        <div class="cd-value">{{ data?.notificationData.MessageTitle }}</div>
        </div>
        <div class="cd-item">
        <div class="cd-title">Notification sent</div>
        <div class="cd-value">{{ appUtils.formatDateWithTime(data?.customerData.DateSent) }}</div>
        </div>
        <div class="cd-item">
        <div class="cd-title">Feedback due date</div>
        <div class="cd-value">{{ appUtils.formatDateWithTime(data?.notificationData.FeedbackDueDate) }}</div>
        </div>
        <div class="cd-item">
        <div class="cd-title">Last reminder sent</div>
        <div class="cd-value">{{ getLastReminderSent() }}</div>
        </div>
    </div>
    <div class="reminder-table-title">
      <span>Scheduled reminders for this notification</span>
    </div>
    <div mat-dialog-content oneDialogContent class="reminder-dialog-content">
      <div class="reminder-table-data">
       <owc-table class="reminder-tbl" *ngIf="dataSource?.length > 0">
  
  <!-- Table Header -->
  <owc-table-header sticky style="z-index:1; border-bottom: none !important; box-shadow: none !important;">
    <owc-table-header-cell>Reminder subject</owc-table-header-cell>
    <owc-table-header-cell>Date sent</owc-table-header-cell>
    <owc-table-header-cell>Reminder scheduled date</owc-table-header-cell>
    <owc-table-header-cell>Status</owc-table-header-cell>
    <owc-table-header-cell>Expand/Collapse</owc-table-header-cell>
  </owc-table-header>

  <!-- Table Body -->
  <owc-table-body>
    @for (element of dataSource; track $index) {
      <owc-table-row>

        <!-- Reminder Subject -->
        <owc-table-simple-cell [title]="element.ReminderSubject">
          <div class="truncate-text">{{ element.ReminderSubject }}</div>
        </owc-table-simple-cell>

        <!-- Date Sent -->
        <owc-table-simple-cell>
          <div *ngIf="element.ReminderSendDate" class="truncate-text" 
               [title]="element.ReminderSendDate">
               {{ appUtils.formatDateWithTime(element.ReminderSendDate) }}
          </div>
          <div *ngIf="element.ReminderDeliveryFailedDate" class="truncate-text" 
               [title]="element.ReminderDeliveryFailedDate">
               {{ appUtils.formatDateWithTime(element.ReminderDeliveryFailedDate) }}
          </div>
          <span *ngIf="!element.ReminderSendDate && !element.ReminderDeliveryFailedDate">--</span>
        </owc-table-simple-cell>

        <!-- Reminder Due Date -->
        <owc-table-simple-cell [title]="element.ReminderDueDate">
          <div class="truncate-text">{{ element.ReminderDueDate }}</div>
        </owc-table-simple-cell>

        <!-- Status -->
        <owc-table-simple-cell>
          <owc-chip class="customer-details-source-chip truncate-text" 
                    oneChip oneChipAppearance="outline">
            {{ displayStatus(element.ReminderSendStatus) }}
          </owc-chip>
        </owc-table-simple-cell>

        <!-- Expand/Collapse -->
        <owc-table-simple-cell (click)="expandToggle(element)" style="cursor: pointer;">
         
            <owc-icon *ngIf="element == expandedElement" name="chevron_up" family="outlined"></owc-icon>
         
           <owc-icon *ngIf="element != expandedElement" name="chevron_down" family="outlined"></owc-icon>
          
        </owc-table-simple-cell>

      </owc-table-row>

      <!-- Expanded Detail Row -->
      <owc-table-row *ngIf="element == expandedElement" class="one-detail-row">
        <owc-table-simple-cell [attr.colspan]="5">
          <div class="reminder-element-detail one-element-detail">
            <div class="one-element-detail-content mat-caption" 
                 [innerHTML]="element.ReminderMessage">
            </div>
          </div>
        </owc-table-simple-cell>
      </owc-table-row>
    }
  </owc-table-body>

</owc-table>

        <div class="noDataViewReminder" *ngIf="dataSource.length < 1">
            <ng-container *ngIf="dataSource.length < 1;">
              No data available.
            </ng-container>
        </div>
      </div>
    </div>
    <div class="na-dialog-actions" style="display:flex">
        <owc-button color="primary" class="mat-primary" (click)="onCloseClick()">Close</owc-button>
    </div>
</div>
  